// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__11g9f","inputDescription":"styles_inputDescription__3yjzN"};